import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingButtonContext = /*#__PURE__*/createContext(undefined);
export const LoadingButtonProvider = ({
  getButtonStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    getButtonStyleOverrides,
    isInLoadingButton: true
  }), [getButtonStyleOverrides]);
  return /*#__PURE__*/_jsx(LoadingButtonContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `LoadingButton` component.
 * Note: The context is only available when the `LoadingButton` component is rendered as an ancestor.
 * @returns loadingButtonContext - The context for the `LoadingButton` component.
 * @returns loadingButtonContext.buttonStyleOverrides - Style overrides to be applied to the `Button` component.
 */
export const useLoadingButtonContext = () => {
  const loadingButtonContext = useContext(LoadingButtonContext);
  return loadingButtonContext;
};